import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  // useSortBy,
  useTable,
} from "react-table";

import Card from "components/card/Card";
import Loader from "components/loader/Loader";
import RowItem from "components/tables/RowItem";

const CustomTable = ({
  columnsData,
  tableData,
  tableTitle,
  currentPage,
  setCurrentPage,
  totalItems,
  pageSize,
  hidePagination,
  isLoading,
}) => {
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  // const [selectedSort, setSelectedSort] = useState("");

  // const handleSortClick = async (sortOrder, orderByField) => {
  //   await updateSorting(sortOrder, orderByField);
  //   setSelectedSort(`${sortOrder}-${orderByField}`);
  // };

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize },
    },
    useGlobalFilter,
    // useSortBy,
    usePagination
  );

  // No need for memoization here, just use tableInstance directly
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  // const [showFilters, setShowFilters] = useState(false);


  const updatePage = (current) => {
    setCurrentPage(current);
  };

  const heading = useColorModeValue("secondaryGray.900", "secondaryGray.300");
  const cardBg = useColorModeValue("white", "#323232");

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      bg={cardBg}
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" pb={2} justify="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          {tableTitle}
        </Text>
      </Flex>
      {!tableData.length || isLoading ? (
        <Box mt={4} mb={8}>
          <Loader />
        </Box>
      ) : (
        <Table
          {...getTableProps()}
          variant="simple"
          color="gray.500"
          mb="24px"
          layout="fixed"
        >
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps()}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                      color={heading}
                    >
                      <RowItem value={cell.value} color="white">
                        {cell.render("Cell")}
                      </RowItem>
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      )}

      {!hidePagination && (
        <Flex direction="row" justifyContent="center">
          <Pagination
            current={currentPage}
            total={totalItems ?? 0}
            pageSize={pageSize}
            onChange={updatePage}
          />
        </Flex>
      )}
    </Card>
  );
};

export default CustomTable;
